const { useCallback } = window.React;
export default function Toggle({ labelName, inputState, cb, id }) {
    const handleToggle = useCallback(() => cb({ id }), [cb, id]);

    return (
        <div className="row mb-3 d-flex align-items-center">
            <div className="col-auto px-3">
                <input
                    id={id}
                    onClick={handleToggle}
                    type="button"
                    className={
                        inputState
                            ? `d-none tgl tgl-light control control-length mixitup-control-active`
                            : "d-none tgl tgl-light control control-length "
                    }
                />
                <label className="tgl-btn mb-0" htmlFor={id}></label>
            </div>
            <div className="col">
                <label
                    className="tgl-btn mb-0"
                    style={{ cursor: "pointer" }}
                    htmlFor={id}
                >
                    <p className="title mb-0 font-weight-bold text-small font-primary" style={{ cursor: "pointer" }}>
                        {labelName}
                    </p>
                </label>
            </div>
        </div>
    );
}
